import React, { useState, useEffect } from 'react'
import {
  Container,
  Grid,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  alpha,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import {
  Person,
  TrendingUp,
  FilterList
} from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { Autocomplete } from '@material-ui/lab'
import * as Yup from 'yup'

import ProduitVenduService from '../../services/ProduitVenduService'
import CliniqueService from '../../services/CliniqueService'
import RecolteCat from '../RecolteCat'

const useStyles = makeStyles((theme) => ({
  root: {
    background: 'linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)',
    minHeight: '100vh',
    padding: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  headerCard: {
    background: 'white',
    borderRadius: 16,
    boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
    marginBottom: theme.spacing(4),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
    overflow: 'hidden',
  },
  headerGradient: {
    background: 'linear-gradient(135deg, #226D68 0%, #2a8c82 100%)',
    padding: theme.spacing(3),
    color: 'white',
    textAlign: 'center',
  },
  headerTitle: {
    fontWeight: 700,
    fontSize: '2rem',
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.5rem',
    },
  },
  headerSubtitle: {
    fontSize: '1.1rem',
    opacity: 0.9,
    fontWeight: 500,
  },
  filterCard: {
    background: 'white',
    borderRadius: 12,
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    padding: theme.spacing(3),
    marginBottom: theme.spacing(4),
    border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  },
  filterHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  filterIcon: {
    marginRight: theme.spacing(2),
    color: '#226D68',
    fontSize: 28,
  },
  filterTitle: {
    fontWeight: 600,
    color: '#226D68',
    fontSize: '1.3rem',
  },
  autocomplete: {
    '& .MuiOutlinedInput-root': {
      borderRadius: 12,
      '&:hover fieldset': {
        borderColor: '#226D68',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#226D68',
        borderWidth: '2px',
      },
    },
  },
  statsGrid: {
    marginTop: theme.spacing(2),
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  emptyIcon: {
    fontSize: 64,
    marginBottom: theme.spacing(2),
    color: theme.palette.divider,
  },
}));

const SearchVentes = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [journee, setJournee] = useState([]);
  const [mois, setMois] = useState([]);
  const [hier, setHier] = useState([]);
  const [annee, setAnne] = useState([]);
  const [filters, setFilters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [
          venteJournee,
          venteHier,
          venteMonth,
          venteYear,
          users
        ] = await Promise.all([
          ProduitVenduService.venteJournee(),
          ProduitVenduService.venteHier(),
          ProduitVenduService.venteMonth(),
          ProduitVenduService.venteYear(),
          CliniqueService.getAllUsers()
        ]);

        setJournee(venteJournee.data);
        setHier(venteHier.data);
        setMois(venteMonth.data);
        setAnne(venteYear.data);
        setFilters(users.data);
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const initialValues = {
    idClient: '',
    nom: ''
  };

  const validationSchema = Yup.object().shape({
    idClient: Yup.number().required("La sélection d'un utilisateur est requise"),
    nom: Yup.string()
  });

  const handleUserChange = async (user) => {
    setSelectedUser(user);
    if (!user) {
      // Reset to all data if no user selected
      const [
        venteJournee,
        venteHier,
        venteMonth,
        venteYear
      ] = await Promise.all([
        ProduitVenduService.venteJournee(),
        ProduitVenduService.venteHier(),
        ProduitVenduService.venteMonth(),
        ProduitVenduService.venteYear()
      ]);

      setJournee(venteJournee.data);
      setHier(venteHier.data);
      setMois(venteMonth.data);
      setAnne(venteYear.data);
      return;
    }

    try {
      const [
        venteGerantJour,
        venteGerantHier,
        venteGerantMonth,
        venteGerantYear
      ] = await Promise.all([
        ProduitVenduService.venteGerantJour(user.speudo),
        ProduitVenduService.venteGerantHier(user.speudo),
        ProduitVenduService.venteGerantMonth(user.speudo),
        ProduitVenduService.venteGerantYear(user.speudo)
      ]);

      setJournee(venteGerantJour.data);
      setHier(venteGerantHier.data);
      setMois(venteGerantMonth.data);
      setAnne(venteGerantYear.data);
    } catch (error) {
      console.error('Erreur lors du filtrage:', error);
    }
  };

  const onSubmit = (values, props) => {
    // Handled by handleUserChange
  };

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
    
        {/* Filtre utilisateur */}
        <Card className={classes.filterCard}>
          <Box className={classes.filterHeader}>
            <FilterList className={classes.filterIcon} />
            <Typography variant="h5" className={classes.filterTitle}>
              Filtrer par Gérant
            </Typography>
          </Box>

          <Formik 
            initialValues={initialValues} 
            validationSchema={validationSchema} 
            onSubmit={onSubmit}
          >
            {(props) => (
              <Form noValidate>
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={8}>
                    <Autocomplete
                      id="idClient"
                      name="idClient"
                      options={filters}
                      getOptionSelected={(option, value) => option.id === value.id}
                      getOptionLabel={(option) => `${option.nom} ${option.prenom} (${option.speudo})`}
                      onChange={(event, user) => {
                        props.setFieldValue("idClient", user?.id || '');
                        props.setFieldValue("nom", user?.nom || '');
                        handleUserChange(user);
                      }}
                      renderInput={(params) => (
                        <Field
                          as={TextField}
                          {...params}
                          name="nom"
                          label="Sélectionner un gérant"
                          variant="outlined"
                          fullWidth
                          className={classes.autocomplete}
                          error={props.errors.nom && props.touched.nom}
                          helperText={<ErrorMessage name='nom' />}
                          required
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <Person 
                                  style={{ 
                                    marginRight: 8, 
                                    color: theme.palette.text.secondary 
                                  }} 
                                />
                                {params.InputProps.startAdornment}
                              </>
                            )
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Box display="flex" alignItems="center" height="100%">
                      <Typography 
                        variant="body2" 
                        color="textSecondary"
                        style={{ fontStyle: 'italic' }}
                      >
                        {selectedUser 
                          ? `Filtré sur: ${selectedUser.nom} ${selectedUser.prenom}`
                          : 'Tous les gérants'
                        }
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Card>

        {/* Cartes de statistiques */}
        {loading ? (
          <Box className={classes.loadingContainer}>
            <TrendingUp style={{ fontSize: 48, color: '#226D68', marginRight: 16 }} />
            <Typography variant="h6" color="textSecondary">
              Chargement des données...
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={3} className={classes.statsGrid}>
            <Grid item xs={12} sm={6} md={3}>
              <RecolteCat 
                title="Aujourd'hui" 
                data={journee}
                icon={<TrendingUp />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <RecolteCat 
                title="Hier" 
                data={hier}
                icon={<TrendingUp />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <RecolteCat 
                title="Mois en cours" 
                data={mois}
                icon={<TrendingUp />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <RecolteCat 
                title="Année en cours" 
                data={annee}
                icon={<TrendingUp />}
              />
            </Grid>
          </Grid>
        )}
      </Container>
    </div>
  );
};

export default SearchVentes;